module.exports = __webpack_public_path__ + "static/media/CUP_WALLET.aff58e55.png";